<template>
  <Field
    as="div"
    class="print-file"
    :name="name"
    :rules="rules"
    v-slot="fieldSlotProps"
  >
    <div class="inner-file-container" :id="`${name}-dropzone`">
      <a
        class="remove-file-button"
        @click="fieldSlotProps.handleReset"
      >
        x
      </a>
      <span
        class="dropzone-text"
      >
        {{ $t('ads.main.dropzone.title') }}
      </span>
      <span
        class="dropzone-text-small"
      >
        {{ $t('ads.main.dropzone.or') }}
      </span>
      <label
        :for="`${name}_chooseFile`"
        class="choose-file-label"
      >
        {{ fieldSlotProps.value?.name ?? this.$t('ads.main.dropzone.button') }}
      </label>
      <input
        type="file"
        @change="fieldSlotProps.handleChange"
        @blur="fieldSlotProps.handleBlur"
        :id="`${name}_chooseFile`"
        ref="file_input"
        class="choose-file-input"
        :accept="$t('ads.main.print.allowed.fileTypes')"
      >

      <ErrorMessage
        v-if="!suppressErrorMessages"
        as="span"
        class="input__error | input-error"
        :name="name"
      />
      <span
        class="dropzone-text-small"
      >
        {{ $t('ads.main.dropzone.maxFileSize') }}</span>

    </div>
  </Field>
</template>

<script>
  import { Dropzone } from "dropzone";
  import { ErrorMessage, Field } from "vee-validate";

  export default {
    components: { ErrorMessage, Field },
    props: {
      name: String,
      rules: [String, Object, Array],
      suppressErrorMessages: {
        type: Boolean,
        default: false,
      },
    },
    mounted() {
      const vm = this
      new Dropzone(`div#${this.name}-dropzone`, {
        autoProcessQueue: false,
        maxFilesize: 50,
        acceptedFiles: this.$t('ads.main.print.allowed.fileTypes'),
        uploadMultiple: false,
        maxFiles: 1,
        autoQueue: false,
        disablePreviews: true,
        url: 'default',
        init: function () {
          this.on('addedfile', function (file) {
            vm.setFile(file);
          })
        }
      });
    },
    emits: ["change"],
    methods: {
      setFile(file) {
        const extension = file.name.substring(file.name.lastIndexOf('.'), file.name.length);
        if (file.size > 52_428_800) {
          this.$emit('change', { file: file, error: 'size' });
        } else if (!this.$t('ads.main.print.allowed.fileTypes').includes(extension)) {
          this.$emit('change', { file: file, error: 'ext' });
        } else {
          this.$emit('change', { file: file });
        }
      },
    }
  }
</script>

<style scoped>

</style>
